// extracted by mini-css-extract-plugin
module.exports = {"delivery-communication-consent":"DeliveryCommunicationConsent__delivery-communication-consent___3u4o_"};